<footer class="footer">
    <div class="container z-3 position-relative">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="footer-link footer-contact-info">
                    <div class="footer-logo">
                        <img src="assets/images/logo.png" alt="The Pdf Leader logo" />
                    </div>
                    <p>Simple, Fast & Secure.</p>
                 
                    <ul class="f-social-link">
                        <li>
                            <a href="https://www.facebook.com/ThePdfLeader" target="_blank" aria-label="Visit our Facebook page">
                                <i class="fab fa-facebook-f" aria-hidden="true"></i>
                                <span class="visually-hidden">Facebook</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/the-pdf-leader/" target="_blank" aria-label="Visit our LinkedIn page">
                                <i class="fab fa-linkedin" aria-hidden="true"></i>
                                <span class="visually-hidden">LinkedIn</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://x.com/thepdfleader" target="_blank" aria-label="Visit our X (formerly Twitter) page">
                                <i class="fab fa-twitter" aria-hidden="true"></i>
                                <span class="visually-hidden">X</span>
                            </a>
                        </li>
                    </ul>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="footer-link">
                    <h5>Important Links</h5>
                    <ul>
                        <li><a href="/watermark-pdf">Watermark PDF</a></li>
                        <!-- <li><a href="pricing.html">Pricing</a></li>
                        <li><a href="security.html">Security</a></li> -->
                    </ul>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="footer-link">
                    <h5>Member area</h5>
                    <ul>
                        <li><a href="sign-in.html">Sign In</a></li>
                        <li><a href="sign-up.html">Sign Up</a></li>
                        <li><a href="forgot.html">Forgot Password?</a></li>
                    </ul>
                </div>
            </div> -->
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="footer-link">
                    <h5>PDF Security</h5>
                    <ul>
                        <li><a href="/protect-pdf">Protect PDF</a></li>
                        <li><a href="/unlock-pdf">Unlock PDF</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="footer-link">
                    <h5>Company</h5>
                    <ul>
                        <li><a href="/about-us">About Us</a></li>
                        <li><a href="/contact-us">Contact Us</a></li>
                        <li><a href="/blog">Blog</a></li>
                        <li><a href="/terms-n-conditions">Terms & Conditions</a></li>
                        <li><a href="/privacy-n-policy">Privacy & Policy</a></li>
                        <!-- <li><a href="faq.html">FAQ </a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center copyright">
                    <p>The PDF Leader '&#64;' 2024. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </div>
</footer>